import React from 'react';
import { Users, Activity, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProjectsPanel = () => {
  const navigate = useNavigate();
  
  const projects = [
    {
      name: 'Foodinverse',
      category: 'Collaboration',
      activityCount: 100,
      members: 4,
      icon: '🍔'
    },
    {
      name: 'Frontera',
      category: 'Creation',
      activityCount: 10,
      members: 3,
      icon: '🌊'
    },
    {
      name: 'YC Club',
      category: 'Creation',
      activityCount: 23,
      members: 1,
      icon: '🧠'
    }
  ];

  return (
    <div className="panel projects-panel">
      <h2 className="panel-title">Active Projects</h2>
      
      <div className="projects-list">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <div className="project-header">
              <span className="project-icon">{project.icon}</span>
              <div className="project-info">
                <h3 className="project-name">{project.name}</h3>
                <span className="project-category">{project.category}</span>
              </div>
            </div>
            <div className="project-stats">
              <div className="project-stat">
                <Activity size={16} />
                <span>{project.activityCount}</span>
              </div>
              <div className="project-stat">
                <Users size={16} />
                <span>{project.members}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button 
        className="view-more-btn"
        onClick={() => navigate('/projects')}
      >
        View More
        <ArrowRight size={16} />
      </button>
    </div>
  );
};

export default ProjectsPanel;
